import { useLayoutEffect as m, useState as b, useCallback as p, useEffect as f } from "react";
import { disableBodyScroll as v, enableBodyScroll as y } from "body-scroll-lock";
const h = (s, n) => {
  m(() => {
    var i;
    if (typeof window > "u") return;
    const r = n.current;
    if (r && s) {
      const d = ((i = document.scrollingElement) == null ? void 0 : i.scrollTop) ?? 0;
      try {
        v(r);
      } catch (t) {
        console.error("Failed to disable body scroll:", t);
      }
      return () => {
        try {
          y(r);
        } catch (t) {
          console.error("Failed to enable body scroll:", t);
        }
        if (document.scrollingElement) {
          const { scrollBehavior: t } = document.documentElement.style;
          document.documentElement.style.scrollBehavior = "initial", document.scrollingElement.scrollTop = d, document.documentElement.style.scrollBehavior = t;
        }
      };
    }
  }, [s, n]);
};
function E(s, n = 145, r = 40) {
  const [i, d] = b(null), t = p((a) => {
    var c;
    const l = (c = a.filter((o) => o.isIntersecting).sort((o, e) => o.boundingClientRect.top - e.boundingClientRect.top)[0]) == null ? void 0 : c.target.id;
    if (l) {
      d((e) => e !== l ? l : e);
      const o = `${window.location.pathname}#${l}`;
      window.history.replaceState(null, "", o);
    }
  }, []);
  return f(() => {
    const u = -(window.innerHeight - (n + r)), l = `-${n}px 0px ${u}px 0px`, c = new IntersectionObserver(t, {
      rootMargin: l
    }), o = s.map(({ elementId: e }) => document.getElementById(e)).filter((e) => e !== null);
    return o.forEach((e) => c.observe(e)), () => {
      o.forEach((e) => c.unobserve(e)), c.disconnect();
    };
  }, [s, t, n, r]), i;
}
export {
  E as a,
  h as u
};
//# sourceMappingURL=useActiveHeadingObserver-CH1gP7YJ.mjs.map
